module.exports = __webpack_public_path__ + "static/img/r_007.7e3179c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_007.jpg
// module id = 3+wr
// module chunks = 1